export const getChatLastViewedAt = state => state.chatLastViewedAt;
export const getCompositionDraft = state => state.compositionDraft;
export const getCurrentLocation = state => state.locationHistory[state.locationHistory.length - 1];
export const getIsAutoShow = state => state.autoShowWidget;
export const getIsMinimized = state => state.isMinimized;
export const getIsSupressedByRules = state => state.suppressedByRules;
export const getIsVisible = state => state.isVisible;
export const getminimizedAt = state => state.minimizedAt;
export const getStage = state => state.stage;
export const getUnreadMessageCount = state => state.unreadMessageCount;
export const getUserComposition = state => state.userComposition;

export default {
  getChatLastViewedAt,
  getCompositionDraft,
  getCurrentLocation,
  getIsAutoShow,
  getIsMinimized,
  getIsSupressedByRules,
  getIsVisible,
  getminimizedAt,
  getStage,
  getUnreadMessageCount,
  getUserComposition,
};
